<template>
  <div v-loading="loading" class="orderDeatilsData">
    <orderTopInfo :order-code="orderCode" :order-type-name="orderTypeName" :order-deatils-data="orderDeatilsData" :settlement-code="settlementCode" @reInitData="initData" />
    <!--顾客详情√-->
    <div class="order-card">
      <div class="title">顾客信息<span v-if="orderDeatilsData.phone" @click="customerDetails()">查看顾客详情<i class="el-icon-arrow-right"></i></span></div>
      <memberInfo :order-deatils-data="orderDeatilsData" />
    </div>
    <!--分销员信息√-->
    <div v-if="orderDeatilsData.distributorInfo || orderDeatilsData.distributionSuperiorInfo" class="order-card">
      <div class="title">分销员信息</div>
      <distributorInfo :order-deatils-data="orderDeatilsData" />
    </div>
    <!--预约信息√- -->
    <div v-if="orderDeatilsData.bookOrderMsgDTO" class="order-card">
      <div class="title">
        预约信息<span @click="seeBookInfo()">查看预约详情<i class="el-icon-arrow-right"></i></span>
        <div class="title-right">
          预约状态：
          <span :class="orderDeatilsData.bookOrderMsgDTO.bookStatus==0||orderDeatilsData.bookOrderMsgDTO.bookStatus==1||orderDeatilsData.bookOrderMsgDTO.bookStatus==3||orderDeatilsData.bookOrderMsgDTO.bookStatus==4?' fs-red':orderDeatilsData.bookOrderMsgDTO.bookStatus==2?'fs-green':'fs-ash'">
            {{ orderDeatilsData.bookOrderMsgDTO.bookStatus==0?'待服务' :orderDeatilsData.bookOrderMsgDTO.bookStatus==1?'服务中':orderDeatilsData.bookOrderMsgDTO.bookStatus==2?'已完成'
              :orderDeatilsData.bookOrderMsgDTO.bookStatus==3?'预约超时':orderDeatilsData.bookOrderMsgDTO.bookStatus==4?'待确认':orderDeatilsData.bookOrderMsgDTO.bookStatus==5?'已预约':orderDeatilsData.bookOrderMsgDTO.bookStatus==-1?'已取消-商家取消'
                :orderDeatilsData.bookOrderMsgDTO.bookStatus==-2?'已取消-预约过期':orderDeatilsData.bookOrderMsgDTO.bookStatus==-3?'已取消-用户取消':orderDeatilsData.bookOrderMsgDTO.bookStatus==-4?'已取消-商家拒绝':'已取消' }}
          </span>
        </div>
      </div>
      <bookInfo :order-deatils-data="orderDeatilsData" />
    </div>
    <!--订单详情√-->
    <div v-if="orderDeatilsData.itemList &&orderDeatilsData.itemList.length !=0" class="order-card">
      <div class="title">订单详情</div>
      <orderInfo :order-deatils-data="orderDeatilsData" />
    </div>
    <!--开位信息√-->
    <div v-if="roomList.customInfoList" class="order-card">
      <div class="title">{{ getRoomType==1?'开房信息':'开位信息' }}<span @click="roommentRecords()">查看{{ getRoomType==1?'房间':getRoomType==2?'床位':'台位' }}详情<i class="el-icon-arrow-right"></i></span></div>
      <roomInfo :order-deatils-data="orderDeatilsData" :room-list="roomList" />
    </div>
    <!--开单信息√-->
    <div v-if="orderDeatilsData.dtoList==null && orderDeatilsData.orderType !=6&&orderDeatilsData.orderType !=5 " class="order-card ">
      <div class="title">开单信息</div>
      <drawABillInfo :order-deatils-data="orderDeatilsData" :is-open="isOpen" />
    </div>
    <!--结算信息√ -->
    <div v-if="orderDeatilsData.orderType != 5" class="order-card">
      <div class="title">
        结算信息
        <span v-if="orderDeatilsData.orderType != 6 &&orderDeatilsData.partPayType ==1" @click="paymentRecords(orderDeatilsData.orderCode,orderDeatilsData.orderType)">查看付款记录<i class="el-icon-arrow-right"></i></span>
      </div>
      <resultInfo :order-deatils-data="orderDeatilsData" :settlement-code="settlementCode" />
    </div>
    <!--退款信息 √-->
    <div v-if="orderDeatilsData.refundMsg4OrderVo" class="order-card">
      <div class="title">
        退款信息
        <span @click="refundRecords(orderDeatilsData.orderId)">查看退款记录<i class="el-icon-arrow-right"></i></span>
      </div>
      <refund :order-deatils-data="orderDeatilsData" />
    </div>
    <!--弹框-->
    <bookDetails ref="refBookDetails" @refreshData="initData" />
    <roomDetails :show.sync="roomDetailsDialog" :detail-data="roomDetailsData" :detail-data-arr="roomDetailsData.customInfoList" :get-room-type="getRoomType" />
    <payDetails :order-deatils-data="orderDeatilsData" @payRecord="getPayRecordData" />
    <refundDetails @refundRecord="getRefundRecordData" />
  </div>
</template>

<script>
import { getOrderDetail4AllDto, getPayCodeList } from './api';
import orderTopInfo from './template/orderTopInfo'; // 顾客信息
import memberInfo from './template/memberInfo'; // 顾客信息
import distributorInfo from './template/distributorInfo'; // 分销员信息
import orderInfo from './template/orderInfo'; // 订单详情
import bookInfo from './template/bookInfo'; // 预约信息
import roomInfo from './template/roomInfo'; // 开位信息
import drawABillInfo from './template/drawABillInfo'; // 开单信息
import resultInfo from './template/resultInfo'; // 结算信息
import refund from './template/refund'; // 退款信息

import bookDetails from './template/bookDetails'; // 预约详情
import roomDetails from './template/roomDetails'; //  房间详情
import payDetails from './template/payDetails'; // 付款记录
import refundDetails from './template/refundDetails'; // 退款记录

export default {
  components: {
    orderTopInfo,
    memberInfo,
    distributorInfo,
    orderInfo,
    bookInfo,
    roomInfo,
    drawABillInfo,
    resultInfo,
    refund,
    bookDetails,
    roomDetails,
    payDetails,
    refundDetails,
  },
  data() {
    return {
      loading: true,
      orderData: {}, // 订单列表信息
      orderDeatilsData: {
        itemList: [],
        payTypeList: []
      }, // 订单详情
      orderCode: '', // 订单号
      orderTypeName: '', // 订单类型名称
      settlementCode: '', // 结算方式
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)
      roomList: [], // 房间列表
      roomDetailsDialog: false, // 展示房间详情
      roomDetailsData: {}, // 房间详情数据
      form: {
        useDetailsDialog: false,
        code: ''
      },
      refundForm: {
        refundDetailsDialog: false,
        id: ''
      },
      // 是否展示-消费人数，手牌号码和签名
      isOpen: {
        sq: 1,
        rs: 1,
        qm: 1,
      },
    };
  },
  // activated
  activated() {
    this.orderData = window.JSON.parse(window.sessionStorage.orderData);
    this.initData();
    this.getPayList();
  },
  methods: {
    // 获取支付方式列表
    getPayList() {
      getPayCodeList({ mainId: window.sessionStorage.mainId }).then((res) => {
        if (res.code == 0 && res.data) {
          res.data.forEach((a) => {
            if (a.payType == 50) {
              this.isOpen.sq = a.isOpen;
            }
            if (a.payType == 51) {
              this.isOpen.rs = a.isOpen;
            }
            if (a.payType == 40) {
              this.isOpen.qm = a.isOpen;
            }
          });
        }
      });
    },
    // 查看订单
    initData() {
      this.loading = true;
      this.orderTypeName = this.Lib.getOrderTypeName(this.orderData.orderType);
      getOrderDetail4AllDto({
        id: this.orderData.orderId,
        orderType: this.orderData.orderType
        // id: this.$route.params.orderId,
        // orderType: this.$route.params.orderType
      }).then((res) => {
        if (res.code === 0) {
          res.data.itemList = res.data.itemList ? res.data.itemList : [];
          res.data.giftItemList = res.data.giftItemList ? res.data.giftItemList : [];
          res.data.giftItemList.forEach((a) => {
            a.isGift = a.activityId ? a.activityType == 3 ? 2 : a.activityType == 4 ? 3 : 1 : 1;
          });
          res.data.itemList = res.data.itemList.concat(res.data.giftItemList);
          res.data.itemList.forEach((a) => {
            a.refundNum = '0';
            a.refundCount = '0';
            a.refundMoney = a.resultPrice;
          });
          res.data.newStatus = this.orderData.orderStatus;
          res.data.orderId = this.orderData.orderId;
          res.data.orderType = this.orderData.orderType;
          res.data.refundStatus = res.data.refundStatus ? res.data.refundStatus : 0;
          this.orderDeatilsData = res.data;
          this.orderCode = res.data.dtoList ? res.data.dtoList.orderCode : res.data.orderCode;

          if (this.orderDeatilsData.orderRoomDetail) {
            this.orderDeatilsData.orderRoomDetail.customInfoList.forEach((list) => {
              list.orderCode = this.orderDeatilsData.orderRoomDetail.orderCode;
            });
            this.roomList = this.orderDeatilsData.orderRoomDetail;
          } else if (this.orderDeatilsData.roomDetailOrder) {
            this.roomList = this.orderDeatilsData.roomDetailOrder;
          }
          this.loading = false;
        }
      });
      this.getPayStatus();
    },
    // 查看顾客详情
    customerDetails() {
      this.$emit('tansferDialog', false);
      window.sessionStorage.customerPhone = this.orderDeatilsData.phone;
      this.$router.push({
        name: 'customer-details'
      });
    },
    // 查看预约详情
    seeBookInfo() {
      this.$refs.refBookDetails.open(this.orderDeatilsData);
    },
    // 查看房间弹框
    roommentRecords() {
      if (this.orderDeatilsData.orderRoomDetail) {
        this.roomDetailsData = this.orderDeatilsData.orderRoomDetail;
      } else {
        this.roomDetailsData = this.orderDeatilsData.roomDetailOrder;
      }
      this.roomDetailsDialog = true;
    },
    // 获取支付方式
    getPayStatus() {
      let countTotal = 0;
      let deductCountTotal = 0;
      let countStatus;
      this.orderDeatilsData.itemList.forEach((a) => {
        countTotal += (a.count ? (a.count * 1) : 0);
        deductCountTotal += (a.deductCount ? (a.deductCount * 1) : 0);
      });
      if (countTotal == deductCountTotal) {
        countStatus = 1;
      } else {
        countStatus = 2;
      }
      this.settlementCode = this.orderDeatilsData.partPayType == 1 ? '部分支付'
        : this.orderDeatilsData.payTypeName == '赊账' ? '赊账'
          : this.orderDeatilsData.resultAmount == 0 ? (countStatus == 1 || this.orderDeatilsData.orderType == 4) ? '划扣' : (this.orderDeatilsData.deductAmount || this.orderDeatilsData.discountAmount || this.orderDeatilsData.fenbiMoney || this.orderDeatilsData.integralMoney || this.orderDeatilsData.couponMoney) ? '优惠全额抵扣' : '入账' : '入账';
    },
    // 赋值组件数据----付款记录
    getPayRecordData(list) {
      this.form = list;
    },
    // 付款记录弹窗
    paymentRecords(code, type) {
      this.form.useDetailsDialog = true;
      this.form.code = code;
      this.form.orderType = type == 3 ? 1 : 0;
    },
    // 赋值组件数据----退款记录
    getRefundRecordData(list) {
      this.refundForm = list;
    },
    // 退款记录弹窗
    refundRecords(id) {
      this.refundForm.refundDetailsDialog = true;
      this.refundForm.id = id;
    },
  }
};
</script>
<style lang="less" scoped>
.orderDeatilsData {
    overflow-x: hidden;
    display: flex;
    flex-flow: column;
}
.order-card{
  .title{
    margin-bottom: 20px;
    color: #999;
    padding-left: 10px;
    margin: 20px 0;
    span{
      padding-left: 10px;
    }
  }
  .title-right{
    display: inline-block;
    float: right;
    color: #333333FF;
    span{
      padding-left: 0;
    }
  }

  .memberInfo{
    padding:10px 30px;
    list-style:none;
    display: flex;
    li{
      margin: 0%;
      .img{
        width: 60px;
        height: 60px;
        border-radius: 50%;

      }
      p{
        font-size: 14px;
        color: #2D2F33;
        line-height: 30px;
      }
    }
    li:nth-child(2){
      padding: 0 200px 0 20px;
    }
  }
}
.fs-ash{
  color:#999999FF!important;;
}
.fs-green{
  color:#2AC410FF!important;;
}
.fs-red{
   color:#FF4949FF!important;
}
</style>
